import React, { useState, useRef } from 'react';
import { pexios, toast} from '../../../utils/functions';
import { history } from '../../../utils/variables';
import { useDispatch, useSelector } from 'react-redux';
import { setRouterData } from '../../../redux/actions';
import { Link } from 'react-router-dom';
import Modal from "../../master/Modal";
import fingerPrint from '../../../assets/images/fingerPrint.gif';
import redFingerPrint from '../../../assets/images/red-fingerPrint.gif';
import FlipCountdown from '@rumess/react-flip-countdown';
import { useTranslation } from 'react-i18next';
// import Flag from "../../../assets/images/rounded-2.png";

const platform = navigator.userAgent.match(/iPad|iPhone/i) ? 'IOS' : 'android';

export default function HomeButton({ userType }) {

    const { location, user } = useSelector(store => store);
    const dispatch = useDispatch();

    const timeOut = useRef(null);

    const [activeClass, setActiveClass] = useState(false);
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);

    //
    const { t } = useTranslation();
    const [dayCounter ,setDayCounter] = useState(false);
    // const today = new Date();
    // const deadLine = new Date('july 23, 2023 00:00:00');
    const [gpsModal,setGpsModal] = useState(false)
    const [ruleModal , setRuleModal] = useState(false)
    const [notif,setNotif] = useState(false)
    const [involveInsurance,setInvolveInsurance] = useState(false)
    const insurances = [
        {value:1, label:'ایران معین'},
        {value:2, label:'ایران'},
        {value:3, label:'آسیا'},
        {value:4, label:'البرز'},
        {value:5, label:'دانا'},
        {value:6, label:'کارآفرین'},
        {value:7, label:'ما'},
        {value:8, label:'کوثر'},
        {value:9, label:'سینا'},
        {value:10, label:'آرمان'},
        {value:11, label:'پارسیان'},
        {value:12, label:'نوین'},
        {value:13, label:'رازی'},
        {value:14, label:'معلم'},
        {value:15, label:'پاسارگاد'},
        {value:16, label:'سامان'},
        {value:17, label:'دی'},
        {value:18, label:'ملت'},
        {value:19, label:'میهن'},
        {value:20, label:'تجارت نو'},
        {value:21, label:'آسماری'}, 
        {value:22, label:'تعاون'},
        {value:23, label:'سرمد'},
        {value:24, label:'سایر'},
        {value:25, label:'حافظ'},
        {value:26, label:'حکمت'},
        {value:27, label:'امید'},
        {value:28, label:'فردا'},
    ]
    const checkPrivacy = user.check_privacy;
    const [acceptance,setAcceptance] = useState('');
    const exeptions = [14,55,89957] 
    const [userInsurance ,setUserInsurance] = useState('')

    function touchIn() {
        clearTimeout(timeOut.current);
        setActiveClass(true);
        setIsTooltipVisible(false);
        setAcceptance(user.check_privacy)
        timeOut.current = setTimeout(() => {
            if (user.type === 'expert') {
                // pexios('/api/change_expert_online', 'post', { online: 1 })
                //     .then(() => {
                //         history.push('/expert-waiting');
                //     });  
                //if(user.id !== 89957){       
                  if(user.check_privacy) {
                  if(navigator.permissions){
                     navigator.permissions.query({name : "geolocation"})
                      .then((result)=>{
                          if(result.state === "denied"){
                            setGpsModal(true)
                          }else{
                              history.push('/expert-waiting')
                            }
                      })
                  }
                  else{
                    navigator.geolocation.watchPosition((info)=>{
                      history.push('/expert-waiting')
                    },()=>{
                      setGpsModal(true)
                    })
                  }
                }else{
                  setRuleModal(true); 
                }
                // }
                // else{
                //   history.push('/expert-waiting')
                // }
               
            }
            else if (userType === 'culprit') {
                pexios('/api/v2/check-user-car-info', 'get').then(res=>{
                    // if(!res.data.status){
                    //   //history.push('/user-car-info');

                    // }else{
                      const info = res.data.info 
                      if(info?.body_insurance_company){
                        setNotif(true)
                            insurances.map((insu) => {                                
                                if(insu.value === info.body_insurance_company){
                                    setUserInsurance(insu.label)
                                }
                            })
                            setInvolveInsurance([1,4,9,13,17,19,20,23,28].includes(info.body_insurance_company))                           
                        }else if(info?.third_insurance_company){
                          setNotif(true)
                            insurances.map((insu) => {
                                if(insu.value === info.third_insurance_company){
                                    setUserInsurance(insu.label)                                  
                                }
                            })
                            setInvolveInsurance([1,4,9,13,17,19,20,23,28].includes(info.third_insurance_company))                            
                        }
                      else{
                          requestAccident()
                        }
                    //}
                })
                
            }
            else history.push('/losses-accident');
        }, 1500);
    }

    function touchOut() {
        clearTimeout(timeOut.current);
        setActiveClass(false);
        setIsTooltipVisible(true);
        ///
        setTimeout(()=>setIsTooltipVisible(false),5000)
    }
    ///
   function requestAccident (){
        pexios('/api/request_new_accident', 'post', location)
            .then(res => {
                const { msg, redirection_link, status, id} = res.data;
                if (msg) {
                    toast(msg, status);
                }
                if (redirection_link) {
                    history.push(redirection_link);
                    return;
                }
                dispatch(setRouterData({id: id, type: 'accident'}));
                history.push('/waiting');
            });
   }
   function handlerPay() {
    if(!involveInsurance && exeptions.includes(user.id)){
      history.push('/receipt')
    }else{
      setNotif(false)
      requestAccident()
    }
   }
   function rejectPay() {
        setNotif(false)
        setActiveClass(false);
   }

    return (
      <div className={activeClass ? "active" : ""}>
        {/*remove later*/}
        <Modal visible={false}>
          <div className="modal-content text-justify p10">
            <p style={{ maxWidth: 350 }}>
              {`بیمه گذار محترم تمام هزینه کارشناسی آنلاین برای شما توسط شرکت بیمه ${userInsurance} پرداخت شده است و این خدمات به صورت کاملا رایگان برای شما انجام خواهد شد.`}
            </p>
            <Link
              to="/user-car-info"
              className="btn btn-block mt20 btn-blue btn-circle"
            >
              تکمیل اطلاعات
            </Link>
          </div>
        </Modal>
        <Modal visible={ruleModal}>
          <div className="modal-content text-justify pb20 pr20 pl20">
          <i className='fas fa-times pt10' onClick={() => setRuleModal(false)} />
            <div style={{ maxWidth: 500 }}>
              <p className='pb10 pr10'>
              {t('GpsModal title',{name: user.full_name})}
              </p>
              <p className='buttonModal-text p10'>
                {t('RuleModal we need your acceptance')}
              </p>
            </div>
            <Link
              to="/rules"
              className="btn btn-block mt20 btn-blue btn-circle"
            >
              {t('Terms and rules')}
            </Link>
          </div>
        </Modal>
        <Modal visible={gpsModal}>
          <div className="modal-content text-justify p20">
            <div style={{ maxWidth: 500 }}>
              <p className='pb10 pr10'>
              {/* {`کارشناس محترم جناب ${user.full_name} عزیز`} */}
              {t('GpsModal title',{name:user.full_name})}
              </p>
              <p className='gpsModal-text p10'>
                {t('GpsModal message')}
              {/* {`با ابراز خرسندی از همکاری با شما، اپلیکیشن همراه بیمه خلیج فارس درجهت تسریع در ارجاع پرونده ها متناسب با شرایط شما نیازمند دریافت موقعیت مکانی تان می باشد. `} */}
              </p>
            </div>
              <a 
              className="btn btn-block mt20 btn-blue btn-circle" 
              href={`https://www.hamrahac.com/education/${user.id}/${user.mobile}`} target="_blank" style={{color :'white'}}> 
             {t('GpsModal btn how to turn on')} 
              </a>
            <button
              onClick={() => setGpsModal(false)}
              className="btn btn-block mt20 btn-blue btn-circle"
            >
                {t('GpsModal btn i know how to turn on')}
            </button>
          </div>
        </Modal>
        <Modal visible={dayCounter}>
                    <div className="modal-content text-justify p20" style={{overflowY : 'auto'}}>
                        <div style={{ maxWidth: 500 }}>
                        <b className="d-flex mt10 mb10 " style={{justifyContent : 'left', fontSize: '25px', color: '#a30505'}}>
                            <FlipCountdown
                                size='large'
                                hideYear
                                hideMonth
                                endAtZero
                                endAt={'2023-7-23 00:00:00'}
                            />
                            {/* <b className="pr10 pl10"> {leftTime.dayas} </b>
                            : 
                            <b className="pr10 pl10">{leftTime.hours} </b>
                            : 
                            <b className="pr10 pl10">{ leftTime.minutes} </b>
                            : 
                            <b className="pr10 pl10">{ leftTime.seconds}</b>  */}
                        </b>
                        <p className='pb10 pr10'>
                        {`کارشناس محترم ${user.full_name} عزیز`}
                        </p>
                        <p className='gpsModal-text p10'>
                            {`سیستم همراه بیمه خلیج فارس `}
                            <strong style={{color : '#5ec3e1'}}>"پولت"</strong>
                            {` داره رشد میکنه و به زودی فقط به دستگاه هایی که اطلاعات موقعیت مکانی شون رو داشته باشه، اجازه فعالیت میده`}
                        </p>
                        </div>
                        <a 
                        className="btn btn-block mt20 btn-blue btn-circle" 
                        href={`https://www.hamrahac.com/education/${user.id}/${user.mobile}#gps`} target="_blank" style={{color :'white'}}> 
                        چجوری روشن کنم؟ 
                        </a>
                        <button
                        onClick={() => {
                            setDayCounter(false)
                            history.push('/expert-waiting')
                        }}
                        className="btn btn-block mt10 btn-green btn-circle"
                        >
                            بلدم، روشن میکنم
                        </button>
                    </div>
        </Modal>
        <Modal visible={notif}>
          {involveInsurance ? (
              <div className="modal-content text-justify p10 notif-modal" style={{ minWidth: 300 }}>
                <p>
                  {t('NotifModal your company paied for you',{userInsurance: userInsurance})}
                  {/* {`بیمه گذار محترم تمام هزینه کارشناسی آنلاین برای شما توسط شرکت بیمه ${userInsurance} پرداخت شده است و این خدمات به صورت کاملا رایگان برای شما انجام خواهد شد.`} */}
                </p>
                {
                  !checkPrivacy ?
                  <div className='d-flex p5' style={{direction: "rtl"}}>

                    <label className='custom-checkbox'>
                        <input type='checkbox' checked={acceptance} onChange={(e) => setAcceptance(e.target.checked)}/>
                        <span className='checkmark'/>
                    </label>
                    <p className='mr35'> 
                      <a style={{textDecoration: 'underline', color : 'blue'}} href='/rules'> {t('Terms and rules')}</a>
                        &nbsp;
                        {t('NotifModal i read and accept')}
                        </p>
                  </div>
                  :
                  <div className='d-flex pb10'style={{'justifyContent' : 'end'}}>
                    <h5 style={{fontSize: '13px'}}> 
                    <a style={{textDecoration: 'underline', color : 'blue'}} href='/rules'> {t('Terms and rules')} </a>
                        &nbsp;   {t('NotifModal Accepted message')}</h5>
                    <i className='fas fa-check pl10' style={{'fontSize':23,'color':'#59f559'}}/>
                  </div>
                }
                <div className="group-btn">
                  <button
                    className={`btn ${acceptance ? 'confirm-btn': 'btn-grey'}`}
                    onClick={() => handlerPay()}
                    disabled={!acceptance}
                  >
                    {t('Accept and continue')}
                  </button>
                  <button
                    className="btn btn-cancle"
                    onClick={() => rejectPay()}
                  >
                    {t('Reject')}
                  </button>
                </div>
              </div>
            ) : (
              <div className="modal-content text-justify p10 notif-modal" style={{ minWidth: 300 }}>
                <p className='mb5 p5'>
                  {t('NotifModal your company doesnt paied for you',{userInsurance:userInsurance})}
                  {/* {`بیمه گذار محترم متاسفانه شرکت بیمه ${userInsurance} هزینه کارشناسی آنلاین را برای شما پرداخت ننموده است , در صورت تمایل به استفاده از خدمات کارشناسی آنلاین ، هزینه را طبق تعرفه بیمه مرکزی(با احتساب مالیات ارزش افزوده) پرداخت نمایید.`} */}
                </p>
                {
                  !checkPrivacy ?
                  <div className='d-flex p5' style={{direction: "rtl"}}>

                    <label className='custom-checkbox'>
                        <input type='checkbox' checked={acceptance} onChange={(e) => setAcceptance(e.target.checked)}/>
                        <span className='checkmark'/>
                    </label>
                    <p className='ml35'> 
                      <a style={{textDecoration: 'underline', color : 'blue'}} href='/rules'>{t('Terms and rules')}</a>
                        &nbsp;
                        {t('NotifModal i read and accept')}
                        </p>
                  </div>
                  :
                  <div className='d-flex mt20 pb10'style={{'justifyContent' : 'end'}}>
                    <h5 style={{fontSize: '13px'}}> 
                    <a style={{textDecoration: 'underline', color : 'blue'}} href='/rules'>{t('Terms and rules')}</a>
                        &nbsp;   {t('NotifModal Accepted message')}</h5>
                    <i className='fas fa-check pl10' style={{'fontSize':23,'color':'#59f559'}}/>
                  </div>
                }
                <div className="group-btn">
                  <button
                    className={`btn ${acceptance ? 'confirm-btn': 'btn-grey'}`}
                    onClick={handlerPay}
                    disabled={!acceptance}
                  >
                    {t('Pay and continue')}
                  </button>
                  <button
                    className="btn btn-cancle"
                    onClick={() => rejectPay()}
                  >
                    {t('Reject')}
                  </button>
                </div>
              </div>
            )}
        </Modal>
        {isTooltipVisible && (
          <div className="buttonTooltip" dir="rtl">
            {t('Button tooltip alert')}
          </div>
        )}
        <div className="rounded" />
        {/* <div className='flag-circle'>
          <img src={Flag}/>
        </div> */}
        <div className="progressbar">
          <svg className="progressbar__svg">
            {activeClass && (
              <circle
                className={`progressbar__svg-circle circle-html shadow-html`}
                cx="85"
                cy="85"
                r="80"
              />
            )}
            {!activeClass && (
              <circle
                className={`progressbar__svg-circle shadow-html`}
                cx="85"
                cy="85"
                r="80"
              />
            )}
          </svg>
        </div>

        <button
          className="home-btn"
          onTouchStart={touchIn}
          onTouchEnd={touchOut}
          onMouseDown={touchIn}
          onMouseUp={touchOut}
        >
          {user.type === "expert" ? (
            <span className={`${activeClass ? "alarmingText" : ""}`}>
              {t('ready to visit')}
            </span>
          ) : (
            <span className={`${activeClass ? "alarmingText" : ""}`}>
              {t('i accident')}
            </span>
            // <>
            //   {activeClass && (
            //     <span style={{ textShadow: "0 0 5px #ff7c7c" }}>
            //       آماده فعالیت
            //     </span>
            //   )}
            //   {!activeClass && <span>آماده فعالیت</span>}
            // </>
            // <>
            //   {activeClass && (
            //     <span style={{ textShadow: "0 0 5px #ff7c7c" }}>
            //       تصادف کردم
            //     </span>
            //   )}
            //   {!activeClass && <span>تصادف کردم</span>}
            // </>
          )}
          {platform === "IOS" ? (
            <img
              src={`${activeClass ? redFingerPrint : fingerPrint}`}
              alt="img"
              className="IOSImg"
            />
          ) : (
              <>
                  <div className="img" style={{backgroundImage: `url('${redFingerPrint}')`, display:`${activeClass ? 'block' :'none'}`}}/>
                  <div className="img" style={{backgroundImage: `url('${fingerPrint}')`, display:`${activeClass ? 'none' :'block'}`}}/>
              </>
            // <img
            //   src={`${activeClass ? redFingerPrint : fingerPrint}`}
            //   alt="img"
            //   className="img"
            // />
          )}
        </button>
      </div>
    );

}
